<form class="change-incorrect-payment-payer-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INCORRECT_PAYMENT.CHANGE_PAYER' | translate }}</h4>
  <section class="astral-section-surface astral-section-surface--compact">
    <app-autocomplete [control]="form.controls['payer']" [itemsSource]="payers"></app-autocomplete>
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
